var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 60",
    role: "img",
    "aria-label": "Amazon Web Services",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    rx: 8,
    fill: "#FF9900"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 38,
    textAnchor: "middle",
    fill: "#232F3E",
    fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
    fontSize: 20,
    fontWeight: 800
  }, "AWS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.b3320742738fce2aafe7d128dce8ebb3.svg";
export { ForwardRef as ReactComponent };